module.exports = __webpack_public_path__ + "img/20_52.4675e0a5.png";